
import { Component,
    Input,
    Output,
    OnInit,
    OnDestroy,
    AfterViewInit,
    ViewChild,
    EventEmitter,
    SimpleChanges,
    ComponentFactoryResolver,
    Type } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs/';

import { RxComponent } from '../../../core/components/common/rx.component';

import { PanelDirective } from './panel.directive';

declare var $: any;

@Component({
    selector: '[itpx-expandable-panel]',
    templateUrl: './expandable-panel.component.html',
    styleUrls: ['./expandable-panel.component.css']
})
export class ExpandablePanelComponent extends RxComponent implements AfterViewInit {

    PanelState: typeof PanelState = PanelState;

    private readonly AnimDuration = 500;
    private readonly BaseHeightPx = 150;
    // To have room for more height if user shrinks screen
    private readonly AbsurdlyHugeHeightPx = 10000;

    @Input()
    private config: any;

    private panelState = new Subject<PanelState>();
    private animationToggle = new Subject<boolean>();

    private toggled: boolean;
    private state = PanelState.Loading;

    @ViewChild(PanelDirective) componentHost: PanelDirective;
    @ViewChild('myContainer') myContainer: any;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver
    ) {
        super();
    }

    ngOnInit() {
        $(this.myContainer.nativeElement).css('max-height', this.config.minHeight || this.BaseHeightPx);

        this.animationToggle
            .throttleTime(this.AnimDuration)
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.toggled = !this.toggled;

                let container = $(this.myContainer.nativeElement);
                let expandedHeight = container.children().first().height();
                let minHeight = this.config.minHeight || this.BaseHeightPx;

                let startHeight = this.toggled ? minHeight : expandedHeight;
                let endHeight = this.toggled ? expandedHeight : minHeight;

                container.css('max-height', startHeight).animate(
                    { maxHeight: endHeight },
                    this.AnimDuration,
                    () => this.toggled && container.css('max-height', this.AbsurdlyHugeHeightPx)
                );
            });

        this.panelState
            .bindToLifecycle(this)
            .subscribe(state => this.state = state);
    }

    ngAfterViewInit() {
        let componentType = <Type<Component>>this.config.component.type;
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);
        let viewContainerRef = this.componentHost.viewContainerRef;
        viewContainerRef.clear();

        let componentRef = viewContainerRef.createComponent(componentFactory);
        let component = <Component>componentRef.instance;
        (component as any).data = this.config.component.data;
        (component as any).panelState = this.panelState;
    }

    private onToggleClicked() {
        this.animationToggle.next(true);
    }
}

export enum PanelState {
    Loading = 0, Enabled = 1, Disabled = 2
}



// WEBPACK FOOTER //
// ./src/app/shared/components/expandable-panel/expandable-panel.component.ts